export enum PartyOrderPaymentPages {
  SearchPage = 1,
  AddressPage = 2,
  InfoPage = 3,
  PaymentConfirmation = 4,
}
